const TaskData = [
  {
    id: 1,
    task: "Create a user flow of social application design",
    status: "Approved"
  },
  {
    id: 2,
    task: "Create a user flow of social application design",
    status: "In review"
  },
  {
    id: 3,
    task: "Landing page design for Fintech project of Singapore",
    status: "In review"
  },
  {
    id: 4,
    task: "Interactive prototype for app screens of deltamine project",
    status: "On going"
  },
  {
    id: 5,
    task: "Interactive prototype for app screens of deltamine project",
    status: "Approved"
  },
]


export default TaskData;